module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "new-shop-page"
    }
  }, [(_vm.personalUpAdv.length > 0) ? _c('banner', {
    attrs: {
      "data": _vm.personalUpAdv
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [(_vm.jpsdGoodsAdvLeftList) ? _c('boutique', {
    attrs: {
      "jpsdGoodsAdvRightList": _vm.jpsdGoodsAdvRightList,
      "jpsdGoodsAdvLeftList": _vm.jpsdGoodsAdvLeftList
    }
  }) : _vm._e(), _vm._v(" "), _c('reference', {
    attrs: {
      "hotPersonalStoreList": _vm.hotPersonalStoreList,
      "hotPersonalStoreGoodList": _vm.hotPersonalStoreGoodList
    }
  }), _vm._v(" "), (_vm.storeList.length > 0) ? _c('store-list', {
    attrs: {
      "data": _vm.storeList
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-872ae9f2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/gold-shop/index.vue
// module id = 1649
// module chunks = 1